module.exports = __webpack_public_path__ + "e98add798d98734f64d59ede44fd61a8.png";